
<template>
  <div class="main-content">

    <loading :active.sync="isLoading"
             :is-full-page="fullPage"></loading>

    <div class="row">
      <div class="col-md-12" style="padding-left: 50px;">
        <b-card class="card-icon  mb-30" style="padding-left: 50px;">
          <h3>Parking voucher report</h3>
          <hr/>
          <div class="row">
            <div class="col-md-6">
              <h4>Filters:</h4>
            </div>
            <div class="col-md-6">

            </div>
          </div>
          <hr/>
          <div class="row" style="margin-bottom: 20px;">
            <div class="col-md-4">
              <div>
                Date
              </div>

              <date-picker   :lang="lang" v-model="start_date" valueType="format" :first-day-of-week="1"></date-picker> to
              <date-picker   :lang="lang" v-model="end_date" valueType="format" :first-day-of-week="1"></date-picker> &nbsp;&nbsp;
            </div>
            <div class="col-md-3">
              <div>
                Outlet
              </div>
              <select class="form-control" v-model="outletId" >
                <option value="0"> -- All -- </option>
                <option :value="outlet.id" v-for="outlet in outlets"> {{ outlet.name }}</option>
              </select>
            </div>
            <div class="col-md-5">
              <button class="btn btn-success float-right" v-b-modal.export-transactions> Export </button>
            </div>
          </div>
        </b-card>
      </div>
    </div>

    <b-modal id="export-transactions" title="Export parking voucher report" @cancel="true" @ok="exportToExcel"   centered>
      <form action="#" class="form-horizontal"  method="post">
        <input type="hidden" name="_token" />
        <div class="form-body">
          <div class="row" >
            <div class="col-md-12">
              <div class="form-group ">
                <label class="control-label ">Please enter your email address:</label> <br/>
                <div >
                  <input class="form-control" type="text"  v-model="email_address" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>

  import { mapGetters, mapActions } from "vuex";

  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import Multiselect from 'vue-multiselect'

export default {
  data() {
    return {
      email_address:"",
      reversal_comments:"",
      disabled:false,
      isLoading: false,
      fullPage: true,
      lang: {
        days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
        placeholder: {
          date: 'Select Date',
          dateRange: 'Select Date Range'
        }
      },
      start_date:"all",
      end_date:"all",
      outletId:0,
      outlets:[]
    };
  },
  computed:{
    isActived: function () {
      return this.pagination.current_page + 1;
    },
    pagesNumber: function () {
      if (!this.pagination.to) {
        return [];
      }
      var from = this.pagination.current_page - this.offset;
      if (from < 1) {
        from = 1;
      }
      var to = from + (this.offset * 2);
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page;
      }
      var pagesArray = [];
      while (from <= to) {
        pagesArray.push(from);
        from++;
      }
      return pagesArray;
    },
    permissions(){
      return localStorage.getItem("permissions");
    },
    role(){
      return localStorage.getItem("role");
    }
  },
  components: {
    Loading,
    DatePicker
  },
  mounted (){
    this.getOutletData();
  },
  methods: {
    ...mapActions(["exportParkingVoucherReport","getOutlets"]),

    getOutletData(){
      let self = this;

      this.getOutlets()
          .then(function (outlets) {
            self.outlets = outlets;

          })
          .catch(function (error) {

          })
    },
    exportToExcel(){
      let self = this;
      this.isLoading = true;

      this.exportParkingVoucherReport({startDate:this.start_date,endDate:this.end_date,outletId:this.outletId, username: this.email_address})
          .then(function () {
            self.isLoading = false;

            self.$bvToast.toast("Export request received. We'll email you the report once its ready", {
              title: 'Success',
              variant: 'success',
              autoHideDelay: 5000,
              appendToast: false
            });

          })
          .catch(function (error) {

            self.isLoading = false;

            console.log(error);
          });
    }

  }
};
</script>
